import React from "react";

const PageTitle = ({ title, className = '' }) => {
  return <h1 className={`${className} h4 fw-bold mb-0`}>{title}</h1>;
};

export default PageTitle;
